import type { ChangeEvent } from 'react';

import { Container, FakeInput, Switch, Slider } from './ToggleSwitch.styled';

type ToggleSwitchProps = {
  id: string;
  checked: boolean;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  dataTestId?: string;
};

const ToggleSwitch = ({ id, checked, onChange, disabled, dataTestId, ...props }: ToggleSwitchProps) => {
  return (
    <Container {...props} data-test-id={dataTestId}>
      <FakeInput
        id={id}
        name={id}
        type="checkbox"
        value={String(checked)}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />

      <Switch htmlFor={id}>
        <Slider />
      </Switch>
    </Container>
  );
};

export default ToggleSwitch;
